import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { BuildingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const BuildingDeptFees = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>

            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title">
                    <h3 className="fontSizeClass">
                      {t(
                        "Schedule of Fees and Charges for the Financial Year 2023- 2024"
                      )}
                    </h3>
                  </div>
                  <div className="mayor-table2 table-3">
                    <p>1) Basic Scale Of Building Permit Fees</p>
                    <p>2) Wet Work Charge &amp; Stacking Fees</p>
                    <p>3) Waste Water Charges (WS)</p>
                    <p>4) Fees For Drainage Development</p>
                    <p>5) Infrastructure Development Fees For Common Passage</p>
                    <p>6) Surcharge For Commercial Use</p>
                    <p>
                      7) Fees For Residential, Govt. Sponsored Educational
                      Institutions &amp; Charitable Building
                    </p>
                    <p>8) Extra Charges For Deviation In Height</p>
                    <p>9) Fees for Retention of unauthorized Structure</p>
                    <p>10) Sketch Fee</p>
                    <p>11) Certified Copy Of Plan</p>
                    <p>12) Fees for change of Technical Person</p>
                    <p>13) Fees And Charges For Change Of Use</p>
                    <p>14) Fees for issuing Completion Certificate</p>
                    <p>15) Fees for Technical Persons</p>
                    <p>16) Guard Posting Charges</p>
                    <p>17) Fees For Repairing Of Existing Building</p>
                    <p>
                      18) Fees for installation of Lift in existing building
                    </p>
                    <p>
                      19) Permit fees for Roof Garden if sanctioned as per norm
                    </p>
                    <p>20) Fees for Swimming Pool</p>
                    <p>
                      21) Fees For allowing temporary change or temporary
                      construction
                    </p>
                    <p>22) Charges for installation of Tower/Antenna/Pole</p>
                    <h2>Table 1</h2>
                    <p>
                      Building Plan Proposal Application Fees (One time at the
                      time of First Submission)
                    </p>
                    <p>for land area upto 500sqm</p>
                    <p>Note :</p>
                    <table>
                      <tr>
                        <th>Proposal Height</th>
                        <th>
                          Fee applicable if primary Use is Residential/
                          Educational/Institutional (Rs.)
                        </th>
                        <th>
                          Fee applicable if primary Use is other than
                          Residential/ Educational/Institutional (Rs.)
                        </th>
                      </tr>
                      <tr>
                        <td>Upto 7 m.</td>
                        <td>2,000/-</td>
                        <td>4,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 7 m. upto 10 m.</td>
                        <td>5,000/-</td>
                        <td>10,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 10 m. upto 12.5 m.</td>
                        <td>10,000/-</td>
                        <td>20,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 12.5 m. upto 15.5 m.</td>
                        <td>12,000/-</td>
                        <td>25,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m. upto 20 m.</td>
                        <td>15,000/-</td>
                        <td>30,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 20 m. upto 40 m.</td>
                        <td>20,000/-</td>
                        <td>40,000/-</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          For any development work entirely funded by MP/MLA LAD
                          fund or approved under any Central Govt or State Govt.
                          Scheme for Urban Renewal Project No application fee
                          will be leived.
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          The items which are not covered in above shall be
                          charged as will be decided by Mayor/MIC.
                        </td>
                      </tr>
                    </table>
                    <h2>Table 1.1</h2>
                    <p>
                      Building Plan Proposal Application Fees (One time at the
                      time of First Submission)
                    </p>
                    <p>for land area upto 500sqm</p>
                    <p>Note :</p>
                    <table>
                      <tr>
                        <th>Proposal Height</th>
                        <th>
                          Fee Applicable For Charitable Institution/Govt.
                          Sponsored Education Institution/Govt. Sponsored Health
                          Care Unit/Place of Worship (Rs.)
                        </th>
                      </tr>
                      <tr>
                        <td>Upto 7 m.</td>
                        <td>200/-</td>
                      </tr>
                      <tr>
                        <td>Above 7 m. upto 10 m.</td>
                        <td>500/-</td>
                      </tr>
                      <tr>
                        <td>Above 10 m. upto 12.5 m.</td>
                        <td>1,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 12.5 m. upto 15.5 m.</td>
                        <td>1,200/-</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m. upto 20 m.</td>
                        <td>1,500/-</td>
                      </tr>
                      <tr>
                        <td>Above 20 m. upto 40 m.</td>
                        <td>2,000/-</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          For any development work entirely funded by MP/MLA LAD
                          fund or approved under any Central Govt or State Govt.
                          Scheme for Urban Renewal Project No application fee
                          will be leived.
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          The items which are not covered in above shall be
                          charged as will be decided by Mayor/MIC.
                        </td>
                      </tr>
                    </table>
                    <h2>Table 1A</h2>
                    <p>
                      Building Plan Proposal Application Fees (One time at the
                      time of First Submission)
                    </p>
                    <p>for land area Above 500 SqM</p>
                    <table>
                      <tr>
                        <th>Proposal Height</th>
                        <th>
                          Fee Application if Primary Use is
                          Residential/Educational/Institutional (Rs.)
                        </th>
                        <th>
                          Fees Applicable if Primary Use is Other than
                          Residential/Educational/Institutional (Rs.)
                        </th>
                      </tr>
                      <tr>
                        <td>Upto 7m.</td>
                        <td>2,500/-</td>
                        <td>5,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 7m upto 10m</td>
                        <td>7,000/-</td>
                        <td>13,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 10m upto 12.5m</td>
                        <td>13,000/-</td>
                        <td>26,000/-</td>
                      </tr>
                      <tr>
                        <td>Avobe 12.5m upto 15.5m</td>
                        <td>16.000/-</td>
                        <td>33,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 15.5m upto 20m</td>
                        <td>20,000/-</td>
                        <td>40,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 20m upto 40m</td>
                        <td>26,000/-</td>
                        <td>50,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 40m upto 60m</td>
                        <td>33,000/-</td>
                        <td>65,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 60m.</td>
                        <td>40,000/-</td>
                        <td>78,000/-</td>
                      </tr>
                    </table>
                    <h2>Table 1.1A</h2>
                    <p>
                      Building Plan Proposal Application Fees (One time at the
                      time of First Submission)
                    </p>
                    <p>for land area Above 500 SqM</p>
                    <p>Note :</p>
                    <table>
                      <tr>
                        <th>Proposal Height</th>
                        <th>
                          Fee Applicable For Charitable Institution/Govt.
                          Sponsored Education Institution/Govt. Sponsored Health
                          Care Unit/Place of Worship (Rs.)
                        </th>
                      </tr>
                      <tr>
                        <td>Upto 7m.</td>
                        <td>250/-</td>
                      </tr>
                      <tr>
                        <td>Above 7m upto 10m</td>
                        <td>700/-</td>
                      </tr>
                      <tr>
                        <td>Above 10m upto 12.5m</td>
                        <td>1,300/-</td>
                      </tr>
                      <tr>
                        <td>Avobe 12.5m upto 15.5m</td>
                        <td>1,600/-</td>
                      </tr>
                      <tr>
                        <td>Above 15.5m upto 20m</td>
                        <td>2,000/-</td>
                      </tr>
                      <tr>
                        <td>Above 20m upto 40m</td>
                        <td>2,600/-</td>
                      </tr>
                      <tr>
                        <td>Above 40m upto 60m</td>
                        <td>3,300/-</td>
                      </tr>
                      <tr>
                        <td>Above 60m.</td>
                        <td>4,000/-</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          For any development work entirely funded by MP/MLA LAD
                          fund or approved under any Central Govt. or State
                          Govt. Scheme for Urban Renewal Project no application
                          fee will be levied.
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          The items which are not covered in above shall be
                          charged as will be decided by Mayor/MIC.
                        </td>
                      </tr>
                      <tr>
                        <td>3)</td>
                        <td>
                          For multiple block above rate will be for each block
                          for same premises
                        </td>
                      </tr>
                    </table>
                    <h2>Table 2</h2>
                    <p>Basic Scale Of Building Permit Fees In Rs.</p>
                    <p>Top</p>
                    <p>Note :</p>
                    <table>
                      <tr>
                        <th>
                          Total Covered Area In All Floors (In Sq. M.) Incldg.
                          All exempted areas
                        </th>
                        <th>
                          Above 500, For every 100 Sqm. To be added with
                          column-VI. Part above 10 Sqm. Shall be taken as 100
                          Sqm. For calculation. Part upto 10 Sqm. Shall be
                          neglected.
                        </th>
                      </tr>
                      <tr>
                        <td>Sl. No</td>
                        <td>Width of means of access</td>
                        <td>Upto 50</td>
                        <td>Above 50 upto 100</td>
                        <td>Above 100 upto 200</td>
                        <td>Above 200 upto 300</td>
                        <td>Above 300 upto 400</td>
                        <td>Above 400 upto 500</td>
                      </tr>
                      <tr>
                        <td>I</td>
                        <td>II</td>
                        <td>III</td>
                        <td>IV</td>
                        <td>V</td>
                        <td>VI</td>
                        <td>VII</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Up to 3 m</td>
                        <td>900</td>
                        <td>1650</td>
                        <td>2250</td>
                        <td>5400</td>
                        <td>10000</td>
                        <td>22000</td>
                        <td>12000</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 3 m &amp; up to 5 m.</td>
                        <td>1200</td>
                        <td>1900</td>
                        <td>2700</td>
                        <td>7000</td>
                        <td>11000</td>
                        <td>24000</td>
                        <td>13200</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 5 m &amp; up to 7 m.</td>
                        <td>1300</td>
                        <td>2000</td>
                        <td>2800</td>
                        <td>7500</td>
                        <td>13200</td>
                        <td>27000</td>
                        <td>15500</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 7 m &amp; up to 9 m.</td>
                        <td>1400</td>
                        <td>2100</td>
                        <td>2900</td>
                        <td>7700</td>
                        <td>14400</td>
                        <td>29000</td>
                        <td>17000</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Above 9 m &amp; up to 12 m.</td>
                        <td>1500</td>
                        <td>2200</td>
                        <td>3000</td>
                        <td>7900</td>
                        <td>15400</td>
                        <td>30800</td>
                        <td>21000</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Above 12 m &amp; up to 25 m.</td>
                        <td>1650</td>
                        <td>2450</td>
                        <td>3200</td>
                        <td>8100</td>
                        <td>18700</td>
                        <td>34000</td>
                        <td>23000</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Above 25 m.</td>
                        <td>1900</td>
                        <td>2700</td>
                        <td>3500</td>
                        <td>8500</td>
                        <td>19500</td>
                        <td>36000</td>
                        <td>25000</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          Basic Permit Fee will mean the fees considering Table
                          2
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          Permit Fee will mean the fees considering Table 2
                          &amp; Table 3
                        </td>
                      </tr>
                      <tr>
                        <td>3)</td>
                        <td>
                          Total Permit Fees will mean the Permit Fee plus other
                          relevant fees and charges
                        </td>
                      </tr>
                      <tr>
                        <td>4)</td>
                        <td>
                          Hereafter Wet Work Charges will be termed as WT, Waste
                          Water Charge as WS, Stacking Fees as ST Infrastructure
                          Development fees for Common Passage as DCP and
                          Surcharge for Non-Residential Building as SC. These
                          will collectively be called &quot;Other Fees &amp;
                          Charges&quot;.
                        </td>
                      </tr>
                      <tr>
                        <td>5)</td>
                        <td>
                          For applying Table 2.,pro-rata fee for proposed area
                          to be calculated considering total covered area of the
                          building .
                        </td>
                      </tr>
                    </table>
                    <h2>Table 2A</h2>
                    <p>
                      Basic scale of Building Permit fees in Rs. for Building
                      u/r 142 of building Rule 2009
                    </p>
                    <p>Top</p>
                    <p>Note :</p>
                    <p>
                      For applying table 2A pro-rata fee for proposed area to be
                      calculated considering total covered area of the building
                      Incldg. All exempted areas .
                    </p>
                    <table>
                      <tr>
                        <th>
                          Total Covered Area In All Floors (In Sq. M.)Incldg.
                          All exempted areas
                        </th>
                        <th>
                          Above 500, For every 100 Sqm. To be added above 500
                          with column-VI. Part above 10 Sqm, shall be taken as
                          100 Sqm. For calculation. Part upto 10 Sqm. shall be
                          neglected.
                        </th>
                      </tr>
                      <tr>
                        <td>Sl. No</td>
                        <td>Height of Proposed Building</td>
                        <td>Upto 50</td>
                        <td>Above 50 upto 100</td>
                        <td>Above 100 upto 200</td>
                        <td>Above 200 upto 300</td>
                        <td>Above 300 upto 400</td>
                        <td>Above 400 upto 500</td>
                      </tr>
                      <tr>
                        <td>I</td>
                        <td>II</td>
                        <td>III</td>
                        <td>IV</td>
                        <td>V</td>
                        <td>VI</td>
                        <td>VII</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Up to 10.00 m</td>
                        <td>1200</td>
                        <td>1900</td>
                        <td>2700</td>
                        <td>7000</td>
                        <td>11000</td>
                        <td>24000</td>
                        <td>13200</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 10.00m. up to 12.50m.</td>
                        <td>1300</td>
                        <td>2000</td>
                        <td>2800</td>
                        <td>7500</td>
                        <td>13200</td>
                        <td>27000</td>
                        <td>15500</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 12.50m. upto 15.50m</td>
                        <td>1400</td>
                        <td>2100</td>
                        <td>2900</td>
                        <td>7600</td>
                        <td>13800</td>
                        <td>28000</td>
                        <td>16300</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 15.50m. upto 20.00m</td>
                        <td>1500</td>
                        <td>2200</td>
                        <td>3000</td>
                        <td>7900</td>
                        <td>14600</td>
                        <td>29500</td>
                        <td>17300</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          Basic Permit Fee will mean the fees considering .
                          Table 2A
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          Permit Fees will mean the fees considering Table 2A
                          &amp; Table 3
                        </td>
                      </tr>
                      <tr>
                        <td>3)</td>
                        <td>
                          Total Permit Fees will mean the Basic Permit Fee plus
                          other relevant fees and charges
                        </td>
                      </tr>
                      <tr>
                        <td>4)</td>
                        <td>
                          Hereafter Wet Work Charges will be termed as WT, Waste
                          Water Charge as WS, Stacking Fees as ST Infrastructure
                          Development fees for Common Passage as DCP and
                          Surcharge for Non-Residential Building SC. These will
                          collectively be called &quot;Other Fees &amp;
                          Charges&quot;.
                        </td>
                      </tr>
                      <tr>
                        <td>5)</td>
                        <td>
                          For Building height more than 20 M fees will be
                          calculated 1.5 times of Sl. No. 4 of Table 2A
                        </td>
                      </tr>
                    </table>
                    <h2>Table 3</h2>
                    <p>II) Govt. project for Lower Income Group</p>
                    <p>
                      III) Total covered area in all floors above 1000 Sq.M. Up
                      to 10000 SqM including staircase &amp; stair lobby
                    </p>
                    <p>1 time</p>
                    <p>2 times</p>
                    <p>3 times</p>
                    <p>3 times</p>
                    <p>4 times</p>
                    <p>1 time</p>
                    <p>1 time</p>
                    <table>
                      <tr>
                        <th>Category</th>
                        <th>Use Group</th>
                        <th>Type of Use</th>
                        <th>
                          Multiplying factor on Scale of Fees as per Table2
                        </th>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>Residential</td>
                        <td>
                          I) Total covered area in all floors upto 1000 Sq.mtr.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          IV) Total covered area in all floors above 10000 Sqm
                          including staircase &amp; stair Lobby.
                        </td>
                        <td>1 time</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>Educational</td>
                        <td>
                          I) Govt./Govt. Aided School, College, Day Care Center,
                          Library etc
                        </td>
                      </tr>
                      <tr>
                        <td>II) Non Govt./Non Aided School, College etc.</td>
                        <td>1 time</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>Institutional</td>
                        <td>
                          I) Govt./Govt. Aided Hospital, Clinic, Dispensary,
                          Sanatorium, Custodial Institution, Mental Hospital,
                          Nursing Home and Pathological lab etc.
                        </td>
                      </tr>
                      <tr>
                        <td>II) Non Govt./Non aided -do-</td>
                        <td>1 time</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>Assembly</td>
                        <td>
                          I) Theatre Hall, Cinema Halls, City Halls, Drive in
                          Theatre, Exhibition Hall, Museum, Skating rink,
                          Gymnasium, Restaurants, Eating House, Hotel,
                          Dormitory(No. of Beds more than 100), Dance Halls,
                          Club-Room, Gymkhana, Passenger terminal, Stadium,
                          Recreation Pier, yoga centers,Pathological Laboratory
                          etc.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          II) Place of Worship, Govt. aided Gymnasium &amp; Yoga
                          Center etc
                        </td>
                        <td>4 times</td>
                      </tr>
                      <tr>
                        <td>E</td>
                        <td>Business</td>
                        <td>
                          I) Office, Bank, Professional Establishment, Court
                          Houses, Telephone room, Computer Office etc.
                        </td>
                      </tr>
                      <tr>
                        <td>II) I. T. Centre, Call Centre</td>
                        <td>3 times</td>
                      </tr>
                      <tr>
                        <td>F</td>
                        <td>Mercantile</td>
                        <td>
                          Shop, Market, Store, Service Facility, Transport
                          Establishments etc.
                        </td>
                        <td>6 times</td>
                      </tr>
                      <tr>
                        <td>G</td>
                        <td>Industrial .</td>
                        <td>
                          Fabrication/Assembly Plant, Laboratory, Power Plant,
                          Smoke House, Refinery, Gas Plant, Mill, Dairy,
                          Factory, Work-shop, Motor Garage, Printing Press etc.
                        </td>
                        <td>4 times</td>
                      </tr>
                      <tr>
                        <td>H</td>
                        <td>Storage</td>
                        <td>
                          Storage House, Ware House, Cold Storage, Freight
                          Depot, Transit Depot, Store House, Public Garage,
                          Truck Terminal, Stable, Barn etc.
                        </td>
                        <td>6 times</td>
                      </tr>
                      <tr>
                        <td>I</td>
                        <td>Hazardous</td>
                        <td>
                          Storage of Highly Combustible and Explosive material,
                          Chemical Acid, Toxic materials, Fly ash, Dust, Fumes
                          etc.
                        </td>
                        <td>4 times</td>
                      </tr>
                    </table>
                    <h2>Table 3.1</h2>
                    <p>Fees Applicable For Charitable</p>
                    <p>Institution/Govt. Sponsored Educational</p>
                    <p>Institution/Govt. Sponsored</p>
                    <p>Sanction of Building Plan (Permit) for any</p>
                    <p>development work entirely funded by MP/MLA</p>
                    <p>LAD fund or approved under any Central Govt.</p>
                    <p>Note :</p>
                    <p>1.</p>
                    <p>
                      The items which are not covered above shall be charged at
                      the rate as will be decided by Mayor/MIC.
                    </p>
                    <p>2.</p>
                    <p>
                      In addition to the Permit Fees for the respective category
                      of building, WT, ST &amp; WS etc. shall be realized for
                      all categories of the building:-
                    </p>
                    <p>3.</p>
                    <p>
                      For use group under small scale industries building in
                      industrial estates approved by Govt. multiplying factor on
                      scale of fees will be 1 (one) times of Table 2for total
                      covered area in all floors. Upto 5000 Sq.M including
                      staircase &amp; stair / lobby &amp; 2 times of Table 2for
                      total covered area in all floors above 5000 Sq.M.
                      including staircase &amp; stair / lobby.
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Type of Use</th>
                        <th>
                          Multiplying factor on Scale of Fees as per Table2
                        </th>
                      </tr>
                      <tr>
                        <td>Health Care Unit/Place of Worship</td>
                        <td>0.1Times</td>
                      </tr>
                      <tr>
                        <td>
                          or State Govt. Scheme for Urban Renewal Project.
                        </td>
                        <td>0.1Times</td>
                      </tr>
                    </table>
                    <h2>Table 4</h2>
                    <p>Wet Work Charge &amp; Stacking Fees</p>
                    <p>
                      Rs. per Sq.m. of total covered area of building for 3
                      months from the date of Commencement
                    </p>
                    <p>
                      Note : In case of Govt./Govt. Aided Educational
                      Institution and Housing Complex under Govt./Semi
                      Govt./Govt. Undertaking stacking fees may be charged @ 50%
                      of the above rates.
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Width of Road/ means of access</th>
                        <th>Wet-Work Charge (WT)</th>
                      </tr>
                      <tr>
                        <td>Rs. per Sq.m. of total covered area</td>
                        <td>Stacking Fee (ST)</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Upto 5 m.</td>
                        <td>20/-</td>
                        <td>15/-</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 5 m. upto 7 m.</td>
                        <td>30/-</td>
                        <td>20/-</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 7 m. upto 15 m.</td>
                        <td>35/-</td>
                        <td>30/-</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 15 m.</td>
                        <td>40/-</td>
                        <td>40/-</td>
                      </tr>
                    </table>
                    <h2>Table 4.1</h2>
                    <p>Wet Work Charge &amp; Stacking Fees</p>
                    <p>
                      Fees Applicable For Charitable Institution/Govt. Sponsored
                      Education Institution/Govt. Sponsored Health Care
                      Unit/Place of Worship
                    </p>
                    <p>
                      Sanction of Building Plan (Permit) for any development
                      work entirely funded by MP/MLA LAD fund or approved under
                      any Central Govt. or State Govt. Scheme for Urban Renewal
                      Project
                    </p>
                    <p>
                      Rs. per Sq.m. of total covered area of building for 3
                      months from the date of Commencement
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Width of Road/ Means of access</th>
                        <th>Wet-Work Charge (WT)</th>
                      </tr>
                      <tr>
                        <td>Rs. per Sq.m. of total covered area</td>
                        <td>Stacking Fee (ST)</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Upto 5 m.</td>
                        <td>2/-</td>
                        <td>1.5/-</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 5 m. upto 7 m.</td>
                        <td>3/-</td>
                        <td>2/-</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 7 m. upto 15 m.</td>
                        <td>3.5/-</td>
                        <td>3/-</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 15 m.</td>
                        <td>4/-</td>
                        <td>4/-</td>
                      </tr>
                    </table>
                    <h2>Table 4A</h2>
                    <p>Waste Water Charges (WS)</p>
                    <table>
                      <tr>
                        <th>For Total Covered Area</th>
                        <th>Rs. 10 per Sqm.</th>
                      </tr>
                    </table>
                    <h2>Table 4.1A</h2>
                    <p>Waste Water Charges (WS)</p>
                    <p>
                      In case of Charitable Institution, Govt. Sponsored
                      Educational
                    </p>
                    <p>
                      Institution, Govt. Sponsored Health Care Unit and Place of
                    </p>
                    <p>
                      Worship and Sanction of Building Plan (Permit) for any
                      development
                    </p>
                    <p>
                      work entirely funded by MP/MLA LAD fund or approved under
                    </p>
                    <p>
                      any Central Govt. or State Govt. Scheme for Urban Renewal
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Project (For Total Covered Area)</th>
                        <th>Rs. 1 per Sqm.</th>
                      </tr>
                    </table>
                    <h2>Table 4B</h2>
                    <p>Fees For Drainage Development</p>
                    <p>
                      Fees for drainage development only applicable for proposal
                      under Section 393,393A of KMC Act,1980
                    </p>
                    <p>
                      Where A is the total proposed total built up area of the
                      Building or Total Land Area whichever is higher .
                    </p>
                    <p>
                      Total payble amount of Drainage Development Change =(Rate
                      * Total built up area).
                    </p>
                    <p>Total built up area 2001 Sq.M Rs.250 per Sq.M</p>
                    <p>
                      Total built up area 5001 Sq.M.to 10000 Sq.M Rs 300/-per
                      Sq.M
                    </p>
                    <p>Total built up area &gt;10000 Sq.M Rs 400/- -per Sq.M</p>
                    <table>
                      <tr>
                        <th>
                          For Wards: 1-6 of Br.1, Wards: 57,58,59,66,67 of
                          Br-VII, Wards: 111,112,113,114 of Br-XI Wards:108,109
                          of Br - XII Wards : 127, 128,129,131,132 of Br-XIV
                          Wards : 134,135, 136,137,138,139,140,141 of Br-XV,
                          Wards 123, 124,125, 126 142,143&amp; 144 of Br-XVI
                        </th>
                        <th>
                          Total built up area upto 2000 sq .m.(a/10+50)Rupees
                          per Sq.M.of covered area subject to maximum of Rs
                          .150/- per Sq.M
                        </th>
                      </tr>
                      <tr>
                        <td>For rest of the wards between ward 07 -100</td>
                        <td>
                          Rate = (A/10+30) Rupees per Sq.M of total built up
                          area subject to Maximum of 100 per Sq.M of covered
                          area
                        </td>
                      </tr>
                      <tr>
                        <td>For rest of the wards between ward 101-144</td>
                        <td>
                          Rate = (A/10+30) Rupees per Sq.M of total built up
                          area subject to Maximum of 150 per Sq.M of covered
                          area
                        </td>
                      </tr>
                    </table>
                    <h2>Table 4.1B</h2>
                    <p>Fees For Drainage Development</p>
                    <p>
                      Fees for drainage development only applicable for
                      proposals under Section 393, 393A of KMC Act,1980
                    </p>
                    <p>
                      In case of Charitable Institution, Govt. Sponsored
                      Educational
                    </p>
                    <p>
                      Institution, Govt. Sponsored Health Care Unit and Place of
                    </p>
                    <p>
                      Worship and Sanction of Building Plan (Permit) for any
                      development
                    </p>
                    <p>
                      work entirely funded by MP/MLA LAD fund or approved under
                    </p>
                    <p>Note :</p>
                    <p>1.</p>
                    <p>
                      There shall be no Drainage Development Fee for the cases
                      having Sanction Plan in respect of retention of any
                      construction in deviation of Sanction Plan under Sec
                      400(1) and 416 of KMC Act., 1980 and dealing under Rule 25
                      (2a &amp; 2b) of Building Rule 1990/Rule 26 (2a &amp; 2b)
                      of Building Rule 2009 and issuance of Occupancy
                      Certificate and doing renovation work (if no additional
                      space is generated).
                    </p>
                    <p>2.</p>
                    <p>
                      No Drainage Development Fee will be charged in cases of
                      Renovation where no additional space is generated .
                    </p>
                    <p>3.</p>
                    <p>
                      In case of revalidation of Building Sanction Plan, full
                      Drainage Development Fee shall be charged at the current
                      schedule of rate. If paid earlier, said amount will be
                      deducted from current fees.[No Drainage Development Fee,
                      however, is to be charged for the plan, which expires
                      before completion of five years from the date of sanction
                      due to non-commencement within two years.]
                    </p>
                    <table>
                      <tr>
                        <th>
                          any Central Govt. or State Govt. Scheme for Urban
                          Renewal Project
                        </th>
                        <th>0.1 time of table 4B.</th>
                      </tr>
                    </table>
                    <h2>Table 5</h2>
                    <p>Infrastructure Development Fees For Common Passage</p>
                    <table>
                      <tr>
                        <th>Group</th>
                        <th>Covered Area/Width of means of access</th>
                        <th>Rate (Rs. per sq. m.)</th>
                      </tr>
                      <tr>
                        <td>Residential Building</td>
                        <td>Upto 200 Sqm. covered area</td>
                        <td>Rs. 20/-</td>
                      </tr>
                      <tr>
                        <td>Exceeding 200 Sqm. covered area</td>
                        <td>Rs. 42/-</td>
                      </tr>
                      <tr>
                        <td>Non-residential/Education/Govt. Aided buildings</td>
                        <td>Upto 9 m. width of means of access</td>
                        <td>Rs. 80/-</td>
                      </tr>
                      <tr>
                        <td>
                          Above 9 m. upto 15.0 m. width of means of access
                        </td>
                        <td>Rs. 100/-</td>
                      </tr>
                      <tr>
                        <td>Above 15.0 m. width of means of access</td>
                        <td>Rs. 120/-</td>
                      </tr>
                    </table>
                    <h2>Table 5.1</h2>
                    <p>Infrastructure Development Fees For Common Passage</p>
                    <p>
                      Fees Applicable For Charitable Institution/Govt. Sponsored
                      Education Institution/Govt.
                    </p>
                    <p>Sponsored Health Care Unit/Place of Worship</p>
                    <p>
                      Sanction of Building Plan (Permit) for any development
                      work entirely funded by MP/MLA LAD
                    </p>
                    <p>
                      fund or approved under any Central Govt. or State Govt.
                      Scheme for Urban Renewal Project
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Group</th>
                        <th>Covered Area/Width of means of access</th>
                        <th>Rate (Rs. per sq. m.)</th>
                      </tr>
                      <tr>
                        <td>Residential Building</td>
                        <td>Upto 200 Sqm. covered area</td>
                        <td>Rs. 2/-</td>
                      </tr>
                      <tr>
                        <td>Exceeding 200 Sqm. covered area</td>
                        <td>Rs. 4/-</td>
                      </tr>
                      <tr>
                        <td>Non-residential Building</td>
                        <td>Upto 9 m. width of means of access</td>
                        <td>Rs. 8/-</td>
                      </tr>
                      <tr>
                        <td>Above 9 m. upto 15 m. width of means of access</td>
                        <td>Rs. 10/-</td>
                      </tr>
                      <tr>
                        <td>Above 15 m. width of means of access</td>
                        <td>Rs. 12/-</td>
                      </tr>
                    </table>
                    <h2>Table 6</h2>
                    <p>Surcharge for Non-Residential Use</p>
                    <table>
                      <tr>
                        <th>Sl. No</th>
                        <th>Width of Road or Means of Access</th>
                        <th>Surcharge</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Upto 5 m.</td>
                        <td>Rs. 100 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 5 m. &amp; upto 9 m.</td>
                        <td>Rs. 200 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 9 m. &amp; upto 15 m.</td>
                        <td>Rs. 350 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 15 m.</td>
                        <td>Rs. 500 per Sq.m. of covered area</td>
                      </tr>
                    </table>
                    <h2>Table 6.1</h2>
                    <p>Surcharge for Non-Residential Use</p>
                    <p>
                      Fees Applicable For Charitable Institution/Govt. Sponsored
                      Education Institution/Govt.
                    </p>
                    <p>Sponsored Health Care Unit/Place of Worship</p>
                    <p>
                      Sanction of Building Plan (Permit) for any development
                      work entirely funded by MP/MLA LAD
                    </p>
                    <p>
                      fund or approved under any Central Govt. or State Govt.
                      Scheme for Urban Renewal Project
                    </p>
                    <p>
                      In case of application u/S 393, 393A, 394 of the KMC
                      Act.1980 - for Small Scale Industrial Building within
                      Kasba Industrial Estate and other Industrial Estate in KMC
                      area under WBSIDC, &#x27;Surcharge for Non-Residential
                      use&#x27; may not be levied.
                    </p>
                    <p>
                      Note: Total covered area in all floors means total covered
                      area in all floors including all exempted areas.
                    </p>
                    <p>
                      Fees for sanction under Rule 25 of Bldg. Rules 1990 &amp;
                      Rule 26 for Bldg. Rules 2009 &amp; U/s 402 of KMC Act,
                      1980 :
                    </p>
                    <p>
                      Fees for internal deviation which involves deviation from
                      the sanctioned plan within the sanctioned covered space
                      and external deviation from the sanctioned plan which does
                      not infringe any building rule will be levied as
                      following:-
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Width of Means of Access</th>
                        <th>Surcharge(Rs)</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Upto 5 m.</td>
                        <td>Rs. 10 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 5 m. upto 9 m.</td>
                        <td>Rs. 20 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 9 m. &amp; upto 15 m..</td>
                        <td>Rs. 35 per Sq.m. of covered area</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 15 m.</td>
                        <td>Rs. 50 per Sq.m. of covered area</td>
                      </tr>
                    </table>
                    <h2>Table 7</h2>
                    <p>
                      For Residential, Govt. Sponsored Educational Institutions
                      &amp; Charitable Bldg.
                    </p>
                    <p>Top</p>
                    <p>
                      Fees for sanction under Rule 25 of Building Rule 1990
                      &amp; Rule 26 of Building Rule 2009 for Buildings other
                      than Residential, Govt. Sponsored Educational Institutions
                      &amp; Charitable Buildings is 2 times of the fees
                      prescribed in Table 7
                    </p>
                    <table>
                      <tr>
                        <th>
                          Fees for sanction u/r. 25(2a) of KMC Bldg. Rules, 1990
                          &amp; u/r. 26(2a) of KMC Bldg. Rules, 2009
                        </th>
                        <th>
                          Fees for sanction u/r. 25(2b) of KMC Bldg. Rules, 1990
                          &amp; u/r. 26(2b) of KMC Bldg. Rules, 2009
                        </th>
                      </tr>
                      <tr>
                        <td>Sl. No</td>
                        <td>
                          Total covered area of effected floors where deviation
                          takes place
                        </td>
                        <td>Amount of fees</td>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Upto 100 sq.m.</td>
                        <td>Rs. 1,500/-</td>
                        <td>
                          1. An administrative charges at following rates on
                          final total covered area after deviation. a) 10% of
                          the basic sanction fees (Table 2 &amp; 3) upto total
                          covered area 300 Sq.M. b) 20% of the basic sanction
                          fees (Table 2 &amp; 3) upto total covered area more
                          than 300 Sq.M. 2. If total covered area after
                          deviation exceeds last sanction total covered area
                          full sanction fees and charges will be levied on
                          excess built up area in addition to administrative
                          charges as stated in (1) above 3) If the deviation
                          U/Rule 26(2b) attracts Rule 69A or 69B of the KMC
                          Building Rule 2009, then fees and charges to be
                          calculated considering Table 16 &amp; 17 respectively.
                          4) In all other cases only administrative charges as
                          stated in (1) will be levied.
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Above 100 sq.m. &amp; upto 200 sq.m.</td>
                        <td>Rs. 3,000/-</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Above 200 sq.m.. &amp; upto 300 sq.m.</td>
                        <td>Rs. 5,000/-</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Above 300 sq.m. &amp; upto 500 sq.m.</td>
                        <td>Rs. 10,000/-</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Above 500 sq.m. &amp; upto 750 sq.m.</td>
                        <td>Rs. 20,000/-</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>Above 750 sq.m. &amp; upto 1000 sq.m.</td>
                        <td>Rs. 32,000/-</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Above 1000 Sqm.</td>
                        <td>Rs. 1500/- per 100 Sq.M. or part thereof Sq.M.</td>
                      </tr>
                    </table>
                    <h2>Table 7A</h2>
                    <p>
                      Sharing of Cost of Compactor Machine/Compactor Station
                    </p>
                    <p>
                      2. Future handling charge of the waste of the compacter
                      station has to be borne by the applicant
                    </p>
                    <p>
                      3. In the extreme case, where Compactor Station is not
                      feasible due to site condition, the cost of one compactor
                      station has to be borne by the applicant as fixed by SWM
                      Department and as decided by Mayor-in-Council.
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Total proposed built-up area</th>
                        <th>Sharing of cost by the applicant</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>5,000 Sq.m. - upto 10,000 Sq.m</td>
                        <td>
                          50% of the cost of Movable Compactor machine as fixed
                          by SWM Department to be taken as Rs. 40 Lacs(Rupees
                          Forty Lacs) which includes all ancillary works and
                          other charges
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>Above 10,000 Sq.m. - upto 20,000 Sq.m.</td>
                        <td>
                          100% of the cost of Movable Compactor machine as fixed
                          by SWM Department to be taken as Rs. 40 Lacs(Rupees
                          Forty Lacs) which includes all ancillary works and
                          other charges
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>Above 20,000 Sq.m.</td>
                        <td>
                          1. An undertaking has to be given for construction of
                          a Compactor Station within the premises as per
                          specification fixed by SWM Department.
                        </td>
                      </tr>
                    </table>
                    <h2>Table 8</h2>
                    <p>For Deviation In Height</p>
                    <p>Under Section 400(1) And Rule 25/Rule26</p>
                    <p>Note :</p>
                    <p>
                      1. While applying Table 8, both A &amp; B will be applied
                      as the case may be.
                    </p>
                    <p>
                      2. If any applicant applies for sanction U/R 25 of the Old
                      Rules, and Rule 26 under the New Rules, before
                      commencement notice, no penalty for height deviation
                      (Table 8) will be charged.
                    </p>
                    <p>
                      3. No. WT., WS., ST &amp; SC will be levied U/R
                      25/26(2)(b) if no extra space is generated.
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Nature of Deviation</th>
                        <th>
                          Extra charge for deviation in height without
                          increasing No. of floors
                        </th>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>For deviation in total height above 1%</td>
                        <td>
                          100% permit fees of one floor area not less than
                          maximum of ground coverage.
                        </td>
                      </tr>
                      <tr>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>
                          For deviation in height of individual floor or part
                          thereof by more than 3% of sanctioned height of the
                          said floor
                        </td>
                        <td>
                          20% permit fees of one floor area of particular floor
                          to which height deviation is effected.
                        </td>
                      </tr>
                    </table>
                    <h2>Table 8A</h2>
                    <p>Fees for plan approved under office Circular No. 9</p>
                    <p>
                      Retention Fees for deviation from Bldg. Permit/any other
                      permission and /or Construction without permission U/s 400
                    </p>
                    <p>General Guideline</p>
                    <p>
                      Generally fees for retention of construction without
                      permission or deviated structure Including shifting of
                      walls, columns, stair etc from the sanctioned permit
                      constructed without prior permission, though within the
                      sanctionable limit shall be calculated on the basis of the
                      following table. However during calculation only the
                      portion on which such construction without permission has
                      been done shall be taken into account. For example if
                      there is a deviation of 100 sq. m. charges shall be levied
                      on the basis of 100 sq. m.
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>
                          Fees for plan approved under office Circular No. 9 of
                          2013-14 dt. 30.12.2013 read with addendum to office
                          Circular No. 9 of 2013-14 dt. 04.01.2014
                        </th>
                        <th>Rs. 100.00.</th>
                      </tr>
                    </table>
                    <h2>Table 9</h2>
                    <p>Above 10 m. Upto 12.5 m.</p>
                    <p>Above 12.5 m.Upto 15.5 m.</p>
                    <p>300/-</p>
                    <p>6,00/-</p>
                    <p>1,200/-</p>
                    <p>For violation of FAR open space etc. (refer Table 12)</p>
                    <p>Above 10 m. Upto 12.5 m.</p>
                    <p>Above 12.5 m. Upto 15.5 m.</p>
                    <p>300/-</p>
                    <p>700/-</p>
                    <p>1400/-</p>
                    <p>Above 10 m. Upto 12.5 m.</p>
                    <p>Above 12.5 m. Upto 15.5 m.</p>
                    <p>300/-</p>
                    <p>750/-</p>
                    <p>1500/-</p>
                    <p>Above 12.5 m. Upto 15.5 m.</p>
                    <p>800/-</p>
                    <p>1,500/-</p>
                    <p>1500/-</p>
                    <p>
                      a) For unauthorized installation of lift Rs. 10,000/-per
                      Sq.m of ground Area covered by the lift for Residential
                      Building &amp; Rs. 20,000/- per Sq.M of Ground Area
                      covered by the lift for Non-Residental Building will be
                      charged.
                    </p>
                    <p>
                      b) For unauthorized multi level car parking(MLCP) Rs.
                      1,00,000/- per car(excluding base level car park for
                      sanction covered area)will be charged..
                    </p>
                    <p>Note :</p>
                    <p>
                      Charges for reconstruction of roof constructed without
                      prior permission under the appropriate rule of the New
                      Building Rules, 2009 shall be (a) Rs. 150/- per sq.m. of
                      the total covered area upto 100 sq.m. (b) Rs. 300/- sq.m.
                      of the total covered area upto 200 sq.m. and (c) Rs. 400/-
                      per Sqm. of the total covered area for above 200 Sqm. WT,
                      WS &amp; ST will be levied as usual.
                    </p>
                    <p>Top</p>
                    <p>Note :</p>
                    <p>1.</p>
                    <p>
                      1) The shortfall in car parking space, if allowed u/s 400
                      (1) read with section 416, the charge shall be:
                    </p>
                    <p>In case of Residential Building,</p>
                    <p>
                      A. a) Rs. 1,00,000/- for shortfall of each car parking
                      where land area is within 300 Sq. M.
                    </p>
                    <p>
                      b) Rs. 1, 50,000/- for shortfall of each car parking where
                      land area is above 300 Sq. M. but within 500 SqM.
                    </p>
                    <p>
                      c) Rs. 2,00,000/- for shortfall of each car parking where
                      land area is above 500 SqM. B. In case of Other then
                      Residential Building, a) 1.5 times of above rates subject
                      to a maximum of Rs. 2,50,000/- per car parking b) Rs.
                      7,50,000/- for shortfall of each Bus / Truck parking.
                    </p>
                    <p>
                      In case of Other then Res. Bldg. 1.5 times of above rates
                      subject to a maximum of Rs. 2,50,000/- per car parking
                    </p>
                    <p>
                      B. Rs. 7,50,000/- for shortfall of each Bus/ Truck
                      parking.
                    </p>
                    <p>2.</p>
                    <p>
                      For Conversion of car parking space in Buildings Sanction
                      u/r 142 of Bldg Rules 2009 of KMC Act ,1980:
                    </p>
                    <p>
                      a)Rs. 5000 per Sq.M. of Conversion Area where Land Area is
                      within 300 sqm.
                    </p>
                    <p>
                      b)Rs. 7500 per Sq.M. of Conversion Area where Land Area is
                      above 300 Sq.M but within 500 Sq. M.
                    </p>
                    <p>
                      c) Rs. 10,000/- pr Sqm of Conversion Area where Land Area
                      above 500 Sqm.
                    </p>
                    <p>3.</p>
                    <p>
                      For partial construction of columns, beams, slabs, stairs
                      etc. the charges shall be @75% of the charges prescribed
                      in Table 9 for residential and commercial use shall be
                      levied.
                    </p>
                    <p>4.</p>
                    <p>
                      In addition to this the sketch fees shall be levied as per
                      Table 9A
                    </p>
                    <table>
                      <tr>
                        <th>
                          Area of deviation from or Construction without bldg.
                          permit
                        </th>
                        <th>Height of Building</th>
                        <th>Basic Rate(Rupees per Sqm.)</th>
                      </tr>
                      <tr>
                        <td>Upto 50 Sq.m.</td>
                        <td>Upto 10.0 m.</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m.</td>
                        <td>200/-</td>
                      </tr>
                      <tr>
                        <td>Above 50 Sq.m upto 80 Sq.m.</td>
                        <td>Upto 10.0 m.</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m.</td>
                        <td>225/-</td>
                      </tr>
                      <tr>
                        <td>Above 80 Sq.m upto 150 Sq.m.</td>
                        <td>Upto 10.0 m.</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m.</td>
                        <td>250/-</td>
                      </tr>
                      <tr>
                        <td>Above 150 Sq.m upto 300 Sq.m.</td>
                        <td>Upto 12.5 m.</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m.</td>
                        <td>400/-</td>
                      </tr>
                      <tr>
                        <td>Above 300 Sq.m upto 500 Sq.m.</td>
                        <td>Upto 15.5 m.</td>
                      </tr>
                      <tr>
                        <td>Above 15.5 m.</td>
                        <td>900/-</td>
                      </tr>
                      <tr>
                        <td>Above 500 Sq.m.</td>
                        <td>-</td>
                        <td>1500/-</td>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>
                          In Case of Charitable Institution , Govt. Sponsored
                          Educational Institution , Govt. Sponsored Health Care
                          Unit and Place of
                        </td>
                        <td>
                          Worship,rebate,(if Prayer for) up to the limit of 50%
                          of the total fees for retention for change of use may
                          be considered by Mayor / MIC. fees will be considered
                          by Mayor
                        </td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>
                          For the items which are not covered above the amount
                          of rebate (if prayed for) will be decided by Mayor. In
                          case of non-residential building the charges shall be
                          levived two times of fees as per in Table 9 along with
                          sur-charge as applicable in Table No. 6 of the
                          schedule
                        </td>
                      </tr>
                    </table>
                    <h2>Table 9A</h2>
                    <p>Fees for Preparation of Sketch</p>
                    <p>Above 300 sqm. upto 500 sqm.</p>
                    <p>Above 500 sqm. upto 1000 sqm.</p>
                    <p>Rs. 2000/-</p>
                    <p>Rs. 3000/-</p>
                    <p>Rs. 4000/-</p>
                    <p>Above 300 sqm. upto 500 sqm.</p>
                    <p>Above 500 sqm. upto 1000 sqm.</p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Group</th>
                        <th>Covered Area</th>
                        <th>Rate (in Rs.)</th>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>For Residential Building</td>
                        <td>Upto 300 sqm. of covered area :</td>
                      </tr>
                      <tr>
                        <td>Above 1000 sqm.</td>
                        <td>Rs. 1500/-</td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>
                          For Educational Institution, Religious Institution and
                          Public Assembly Building and Govt. Hospital etc.
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>
                          For Business Building, Mercantile Building, Industrial
                          Building, Nursing Home, Clinics, Path Labs, Eating
                          House, Hotels, Restaurants.
                        </td>
                        <td>Upto 300 sqm. of covered area</td>
                      </tr>
                      <tr>
                        <td>Above 1000 sqm.</td>
                        <td>Rates will be double the above rates</td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>Hazardous Building, Storage Godown</td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>Others</td>
                      </tr>
                    </table>
                    <h2>Table 10</h2>
                    <p>Certified Copy Of Plan</p>
                    <p>(Sanction Plan, Completion Plan, D/Sketch etc.)</p>
                    <p>
                      For A0 (841mm x1189mm) &amp; A1 (594mm x 841mm) size
                      drawing sheet.
                    </p>
                    <p>Note :</p>
                    <p>
                      1. 2 times the above fees will be charged if a person
                      other than the owner applies for.
                    </p>
                    <p>
                      2. Application fee for certified copy of plan to be
                      charged @ Rs. 100/- per application.
                    </p>
                    <p>Fees And Charges For Change Of Use Under Sec 416</p>
                    <p>A. For Issuing Sanction</p>
                    <p>
                      Any change of use from one category to other category only
                      Permit fees (without Wet Work Charge, Waste Water charge,
                      Stacking fee and Infrastructure Development fee for common
                      passage), for the respective category of Building to which
                      the conversion proposed, according to the width of road
                      shall be charged. In addition to this a Surcharge
                      including Development fees as per Town &amp; Country
                      Planning Act shall be charged.
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Size</th>
                        <th>Rate (in Rs.)</th>
                      </tr>
                      <tr>
                        <td>
                          (This size is also to be considered for the drawing
                          sheet sizes exceeding 1.5 times A2 size)
                        </td>
                        <td>2500/-</td>
                      </tr>
                      <tr>
                        <td>
                          For A2 (420mm x 594mm) size &amp; below as well as
                          upto 1.5 times A2 size
                        </td>
                        <td>1500/-</td>
                      </tr>
                    </table>
                    <h2>Table 11</h2>
                    <p>Fees for change of use</p>
                    <p>Note :</p>
                    <p>1.</p>
                    <p>
                      Change of use if permitted, from one category to other
                      category within the same use group 25% of the usual
                      Sanction fees excluding WT, WS, ST &amp; SC (Provided
                      existing use is already sanctioned or it was existing
                      before 01.4.84) is to be paid.
                    </p>
                    <p>2.</p>
                    <p>
                      Change of use if permitted, from one category to other
                      category not within the same use group, 100% of usual
                      sanction fees excluding WT, WS, ST &amp; SC (Provided
                      existing use is already sanctioned or it was existing
                      before 01.4.84) is to be paid.
                    </p>
                    <p>3.</p>
                    <p>
                      Change of use if permitted, from non residential to
                      residential, 25% of usual Sanction fees as per category
                      being applied for excluding WT, WS, ST &amp; SC (Provided
                      existing use is already sanctioned or it was existing
                      before 01.4.84) is to be paid.
                    </p>
                    <p>4.</p>
                    <p>
                      Above rates are applicable in cases applications are made
                      within the validity period of the present sanction plan
                      and before obtaining completion certificate. If any
                      application is made after obtaining completion certificate
                      or after expiry of validity of sanction, full sanction
                      fees including SC but excluding WT, WS, ST will be
                      charged.
                    </p>
                    <p>5.</p>
                    <p>
                      A fine of Rs. 100/- per Sqm. per month considering floor
                      area is to be levied for minimum one month only in case of
                      change of use from non-residential to residential already
                      caused contravening any provision of relevant section, if
                      such area is permitted by the authority. This fine in
                      other cases, however, will be for minimum six months in
                      addition to two times the other fees &amp; charges as per
                      Table 9 when sanctioned by the authority in relaxation of
                      Rule 51 &amp; Rule 61 of Building Rule 1990 or Rule 59
                      &amp; Rule 69 of Building Rule 2009.
                    </p>
                    <p>6.</p>
                    <p>
                      Under special circumstances, if change of use is granted
                      after use as fait accompli, one and half times of the fees
                      of respective scale for respective use group as per Item 1
                      of Table 11, will be charged.
                    </p>
                    <p>7.</p>
                    <p>
                      When the residential Building converted to non-residential
                      building the fees for open space infringement of rule
                      shall be charges as per Table-9
                    </p>
                    <p>8.</p>
                    <p>
                      When covered area is within 50 SqM. Fee for violation of
                      means of access &amp; FAR will be twice the basic permit
                      fees. Payable amount is to be calculated as per the
                      guidelines given below:-
                    </p>
                    <p>
                      Guidelines for calculation of permit fees for change of
                      use :
                    </p>
                    <p>
                      Permit fees u/S 416 in the existing building where
                      sanctioned plan is submitted the rates will be charged
                      considering whole building on pro-rata basis &amp;
                      considering basic rates and multiplying factor with
                      Surcharge &amp; Infrastructural Development fees but
                      without WT, WS &amp; ST. No SC will be charged in cases of
                      conversion from Non-residential to other use group. When
                      pro-rata calculations is not possible due to want of
                      sanctioned plan the usual charges will be multiplied by
                      five times to arrive at leviable charges.
                    </p>
                    <p>
                      Determination of fees for retention of UNAUTHORIZED
                      STRUCTURE which are allowed by Special Officer (Bldg.) and
                      Municipal Authority
                    </p>
                    <p>
                      If any unauthorized construction which are allowed by
                      Special Officer (Bldg.) U/S 400(1) of KMC Act., 1980 and
                      subsequently accepted by the Mayor-in-Council / Board of
                      Administrators, the schedule of fees and charges will be
                      calculated as per following Table :--
                    </p>
                    <p>Top</p>
                    <table>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Probable date/period when change took place</th>
                        <th>Converted use group</th>
                        <th>Amount of fees to be paid</th>
                        <th>Remarks</th>
                      </tr>
                      <tr>
                        <td>1</td>
                        <td>Before 1.4.84</td>
                        <td>
                          Guest House, Boarding House, Hotel, Restaurant, Eating
                          House, Nursing Home, Clinics, PathLabs.
                          Marriage/Ceremonial House, Commercial/Business and
                          other non polluting manufacturing units.
                        </td>
                        <td>
                          Permit fees including Surcharge &amp; Development fees
                          (without Wet Work Charges, Waste Water Charge &amp;
                          Staking Fees) at current Rates for the respective
                          category of Building to which the use converted.
                        </td>
                        <td>
                          Since this use group existed before 1.4.84 the
                          infringement if any, shall be retained &amp; accepted
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>From 1.4.84</td>
                        <td>
                          Guest House, Boarding House, Hotel, Restaurant, Eating
                          House, Nursing Home, Clinics, PathLabs.
                          Marriage/Ceremonial House, Commercial/Business and
                          other non polluting manufacturing units.
                        </td>
                        <td>
                          In addition to the Permit fees at current Rates
                          including Surcharge &amp; Development fees. (without
                          Wet Work Charges, Waste Water Charges &amp; Stacking
                          Fees) for the respective category of Bldg. to which
                          the use converted along with a penalty for six months
                          @ Rs. 100.00 per sq. m. per month shall be charged
                        </td>
                      </tr>
                    </table>
                    <h2>Table 12</h2>
                    <p>
                      Determination of fees for retention of unauthorized
                      structures
                    </p>
                    <p>
                      The above system of calculation of fees and charges will
                      be based on market value of unauthorized area as per
                      market value determined by Directorate of Registration and
                      Stamp Revenue. Finance Department Govt. of W.B IGR value
                      is available in the Website -
                      &quot;wbregistration.gov.in&quot;. Executive Engineer
                      (Building) of all Boroughs may enter into the above said
                      website to determine the IGR value and to calculate the
                      above stated fees and charges. The above calculation has
                      to be made in lieu of following :-
                    </p>
                    <p>a) Fees for infringement of permissible FAR</p>
                    <p>b) Fees for infringement of Open Spaces</p>
                    <p>c) Table 9A (Credited Copy of Sketch Fee)</p>
                    <p>d) Surcharge for non-residential use</p>
                    <p>
                      e) Fees for conversion of Car Parking space in Building
                      Sanctioned U/R-142 of KMC Building Rule 2009 of KMC Act
                      1980
                    </p>
                    <p>
                      Other parameter in connection with the calculation of fees
                      and charges of unauthorized construction will be as per
                      prevailing schedule of rates.
                    </p>
                    <p>
                      Determination of fees for retention of unauthorized change
                      of Use areas which are allowed by Spl. Officer (Building)
                      and Municipal Authority
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No</th>
                        <th>Height of Building</th>
                        <th>% of Market Value if IGR to be considering</th>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>Up to 10.0 M</td>
                        <td>@ 12.5% of I.G.R Value</td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>More than 10.0 M</td>
                      </tr>
                      <tr>
                        <td>Up to 15.5 M</td>
                        <td>@ 37.5% of I.G.R Value</td>
                      </tr>
                      <tr>
                        <td>3)</td>
                        <td>More than 15.5 M</td>
                      </tr>
                      <tr>
                        <td>Up to 21.5 M</td>
                        <td>@ 42.5% of I.G.R Value</td>
                      </tr>
                      <tr>
                        <td>4)</td>
                        <td>More than 21.5 M</td>
                        <td>@ 75% of I.G.R Value</td>
                      </tr>
                    </table>
                    <h2>
                      Table 12A (Change of use) Determination of fees for
                      retention of unauthorized change of Use areas
                    </h2>
                    <p>
                      Note : The above system of calculation of fees &amp;
                      charges will be based on market value determined as per
                      valuation maintained by Directorate of Registration &amp;
                      Stamp Revenue, Finance Department, GoWB. The charges shall
                      be percentage as given in the Table 12A (above) of the
                      difference in market value between actual use of
                      sanctioned use.If such differences is found negative, 50%
                      of the sanction fees as per category being applied will be
                      levied
                    </p>
                    <p>
                      Other parameter in connection with the calculation of fees
                      and charges of unauthorized constructions will be as per
                      prevailing schedule of rates.
                    </p>
                    <p>
                      The above calculation has to be made in liew of following
                      :-
                    </p>
                    <p>(a) Table 9A (Credited copy of Sketch Fee)</p>
                    <p>(b) Surcharge for non-residential use.</p>
                    <p>Fees for change of Technical Person</p>
                    <p>
                      For Change of LBS / Architect / ESE / Geo-Tech Engineer
                      may be made &amp; an Amount of Rs. 10,000/- for each such
                      changes will be charged. In Case department take any
                      disciplinary action for professional misconduct against
                      LBS / Architect / ESE / Geo-Tech Engineer or in case of
                      death of any professional, in that case such change of
                      professional will not be charged
                    </p>
                    <p>
                      For Extension of time period for completion of work in
                      accordance with the sanctioned plan as per provision of
                      Section 399 of KMC Act.
                    </p>
                    <p>
                      1) For extension of validity of plans (if permitted), the
                      permit fees as per current rates for the respective
                      category of Building shall be charged according to the
                      width of the Road (as per Table 2 &amp; 3)
                    </p>
                    <p>
                      2) In case of incomplete building the balance portion that
                      remains to be constructed will be taken into consideration
                      for payment of charges.
                    </p>
                    <p>
                      3) Where the construction could not be commenced and / or
                      plinth intimation has been made within the stipulated
                      period of time, the fees shall be charged upon the whole
                      building as per current rates (Table 2 &amp; 3) excluding
                      all other fees &amp; charges as per prevailing rate
                      restricting the validity period upto five yeats from the
                      original date of sanction. But further 5 years extension
                      of the validity can be granted from the date of such
                      extension if total permit fees is provided as per
                      prevailing schedule.
                    </p>
                    <p>4) For cases where:</p>
                    <p>a) Construction up to plinth level is completed:-</p>
                    <p>
                      i) 90% of the total permit fees for the portion to be
                      revalidated will be levied.
                    </p>
                    <p>
                      b) Structural works like columns, slabs in framed
                      structure building or in any masonry building slab, beams,
                      bricks column, load bearing wall etc. are completed:-
                    </p>
                    <p>
                      i) 60 % of total permit fees will be charged when no
                      floor/roof slab has been cast.
                    </p>
                    <p>
                      ii) 50% of total permit fes will be charged when
                      floor/roof slab has been cast.
                    </p>
                    <p>
                      c) Partition walls, doors and windows, stair, lift machine
                      room &amp; other necessary finishing works are not
                      completed:-
                    </p>
                    <p>
                      i) 10 % of total permit fees will be levied upto 300 Sq.
                      M. of floor area.
                    </p>
                    <p>
                      ii) 20% of total permit fees will be levied for more than
                      300 Sq. M. of floor area.
                    </p>
                    <p>
                      5) If revalidation extension of time period is allowed to
                      a Sanctioned Plan and if it is found that the total
                      covered area of the said plan is more than that
                      permissible under prevailing Building Rule, the prmit fees
                      including all other relevant charges for the excess
                      covered area will be charged at 2 time of the present
                      fees.
                    </p>
                    <p>
                      6) If application for revalidation is made after expiry of
                      sanction plan penalty will be levied in addition to the
                      fees as stipulated in point (4) above :- i) Within 3 month
                      5% of the fees for remaining work is to be calculated as
                      stated above. ii) More than 3 month to 6 month 10% of the
                      fees for remaining work is to be calculated. iii) More
                      than 6 month to 1 year 15% of the fees for remaining work
                      is to be calculated. iv) More than 1 year 20% of the fees
                      for remaining work is to be calculated. 7) If application
                      of revalidation is made after expiry of sanction plan and
                      the construction of Building is found complete following
                      penalty is to be imposed :- i) Within 3 month 50% of the
                      basic sanction fees. (Table 2 &amp; 3) ii) More than 3
                      month to 6 month 60% of the basic sanction fees. (Table 2
                      &amp; 3) iii) More than 6 month to 1 year 75% of the basic
                      sanction fees. (Table 2 &amp; 3) iv) More than 1 year 100%
                      of the basic sanction fees. (Table 2 &amp; 3)
                    </p>
                    <table>
                      <tr>
                        <th>Sl. No</th>
                        <th>Height of Building</th>
                        <th>% of Market Value if IGR to be considering</th>
                      </tr>
                      <tr>
                        <td>1)</td>
                        <td>Up to 12.50 Meter</td>
                        <td>15</td>
                      </tr>
                      <tr>
                        <td>2)</td>
                        <td>More than 12.50 Meter</td>
                      </tr>
                      <tr>
                        <td>Up to 18.00 Meter</td>
                        <td>45</td>
                      </tr>
                      <tr>
                        <td>3)</td>
                        <td>More than 18.00 Meter</td>
                      </tr>
                      <tr>
                        <td>Up to 21.50 Meter</td>
                        <td>50</td>
                      </tr>
                      <tr>
                        <td>4)</td>
                        <td>More than 21.50 Meter</td>
                        <td>60</td>
                      </tr>
                    </table>
                    <h2>Table 13</h2>
                    <p>Fees for issuing Completion Certificate</p>
                    <p>A) Residential, Educational &amp; Institutional</p>
                    <p>
                      B) For Govt. sponsored Educational, Institutional &amp;
                      Charitable Building Etc. Irrespective of covered area in
                      all floors : Rs. 1000/- only
                    </p>
                    <p>50</p>
                    <p>Note :</p>
                    <p>
                      1.Rate Shall be determined by considering Total Sanctioned
                      Area of a Use Group.CC/Partial CC Fees Payable will be sum
                      of (Use Group wise Area for which CC/PCC is being Granted
                      multiplied by Corresponding Rate)
                    </p>
                    <p>2. Additional fees payable for partial CC cases :</p>
                    <p>
                      In addition to the normal fees as per the above table for
                      the area for which PCC is being granted, the following fee
                      will be applicable.
                    </p>
                    <p>
                      If land Area upto 300 Sq.M. and Primary Use Group is
                      Residential / Educational/ Institutional , additional fee
                      of Rs. 2000/- applicable.
                    </p>
                    <p>
                      If Land Area above 300 Sq.M. and upto 500 Sq.M. and
                      Primary Use Group is Residential / Educational/
                      Institutional , additional fee of Rs. 5000/- applicable.
                    </p>
                    <p>
                      If Land Area above 500 Sq.M. or Primary Use Group is
                      Commercial in nature , additional fee of Rs.10,000/-
                      applicable.
                    </p>
                    <p>
                      For Govt sponsored Educational, Gove. Sponsored
                      Institutional &amp; Charitable Buildings additional fee of
                      Rs. 1,000/- applicable.
                    </p>
                    <p>
                      3. In case of Building funded entirely by MP/MLA/SS fees
                      for CC will not be levied.
                    </p>
                    <p>
                      4. For Completion Certificate of Buildings which are
                      already occupied (fully or partially) - 4 times of the
                      fees as per Table 12 will be levied for the portion which
                      has been occupied, for rest portion normal fees as per
                      Table 12 will be applicable.
                    </p>
                    <p>Miscellaneous</p>
                    <p>i)Fees for certified copies of order etc.CC</p>
                    <p>ii) Application fee for certified copy of Bldg. Plan</p>
                    <p>Rs. 100/-</p>
                    <p>Rs. 400/- plus application fee of Rs. 100/-</p>
                    <p>Top</p>
                    <p>Fees for Technical Personnel</p>
                    <table>
                      <tr>
                        <th>Use Group</th>
                        <th>Rate in Rupees per Sq.M.</th>
                      </tr>
                      <tr>
                        <td>
                          If covered area is within 300 Sq. M. including all
                          exemp.area
                        </td>
                        <td>
                          If covered area is above 300 Sq. M.including all
                          exemp.area
                        </td>
                      </tr>
                      <tr>
                        <td>20</td>
                        <td>30</td>
                      </tr>
                      <tr>
                        <td>C) For Other Categories of Use except A &amp; B</td>
                        <td>For Any covered Area including all exemp.area</td>
                      </tr>
                      <tr>
                        <td>iii)Inspection fee to inspect Bldg. Plan</td>
                        <td>Rs. 1000/-</td>
                      </tr>
                    </table>
                    <h2>Table 14</h2>
                    <p>Late Fees</p>
                    <p>
                      Late fee for renewal of License to be applicable from 1st
                      July
                    </p>
                    <p>1.Late fee for renewal of License</p>
                    <p>2.Late fee for renewal of License</p>
                    <p>3.Late fee for renewal of License</p>
                    <p>:</p>
                    <p>:</p>
                    <p>Rs. 500/- per month or part thereof for E.S.E.</p>
                    <p>
                      Rs. 1000/- per month or part thereof for Geo-Tech Eng.
                    </p>
                    <p>Rs. 4000/- per month or part thereof for Structural</p>
                    <p>Reviewer &amp; E.S.E.-I (Combined)</p>
                    <table>
                      <tr>
                        <th>Technical Personnel</th>
                        <th>Category</th>
                        <th>Fees (in Rs.) for 1 yr</th>
                        <th>Fees (in Rs.) for 3 yrs.</th>
                      </tr>
                      <tr>
                        <td>Licensed Building Surveyor</td>
                        <td>Class - I</td>
                        <td>2000/-</td>
                        <td>4800/-</td>
                      </tr>
                      <tr>
                        <td>Licensed Building Surveyor</td>
                        <td>Class - II</td>
                        <td>1000/-</td>
                        <td>2400/-</td>
                      </tr>
                      <tr>
                        <td>Empanelled Structural Engineer</td>
                        <td>Class - I</td>
                        <td>3500/-</td>
                        <td>8400/-</td>
                      </tr>
                      <tr>
                        <td>Empanelled Structural Engineer</td>
                        <td>Class - II</td>
                        <td>2500/-</td>
                        <td>6000/-</td>
                      </tr>
                      <tr>
                        <td>Empanelled Geo-Technical Engineer</td>
                        <td>Class - I</td>
                        <td>3500/-</td>
                        <td>8400/-</td>
                      </tr>
                      <tr>
                        <td>Empanelled Geo-Technical Engineer</td>
                        <td>Class - II</td>
                        <td>2500/-</td>
                        <td>6000/-</td>
                      </tr>
                      <tr>
                        <td>Structural Reviewer &amp; E.S.E.-I</td>
                        <td>Combined</td>
                        <td>12000/-</td>
                        <td>30000/-</td>
                      </tr>
                      <tr>
                        <td>4.Late fee for renewal of License</td>
                        <td>:</td>
                      </tr>
                      <tr>
                        <td>:</td>
                        <td>Rs. 250/- per month or part thereof for L.B.S</td>
                      </tr>
                      <tr>
                        <td>
                          5.Fees for issuing duplicate card for LBS &amp; ESE
                          /Geo-Tech Engineer
                        </td>
                        <td>:</td>
                        <td>Rs. 1200/-</td>
                      </tr>
                      <tr>
                        <td>
                          6.Fees for issuing duplicate card Structural Reviewer
                          &amp; E.S.E.-I (Combined)
                        </td>
                        <td>:</td>
                        <td>Rs. 1200/-</td>
                      </tr>
                    </table>
                    <h2>Table 15</h2>
                    <p>
                      Fees For repairing Of Existing Building U/s 410 of KMC
                      Act, 1980 &amp; Under Rule 3(2) (e)/(l) Of Building Rules
                      2009
                    </p>
                    <p>II) Brick Works</p>
                    <p>300/- per Cum</p>
                    <p>350/- per Cum</p>
                    <p>
                      For Building other than residential use group fees U/R
                      3(2) shall be charged using multiplying factor applicable
                      for respective group.Other fees &amp; charges will be
                      levied as usual
                    </p>
                    <p>II) Brick Works</p>
                    <p>350/- per Cum</p>
                    <p>400/- per Cum</p>
                    <p>II) Brick Works</p>
                    <p>350/- per Cum</p>
                    <p>400/- per Cum</p>
                    <p>II) Brick Works</p>
                    <p>400/- per Cum</p>
                    <p>500/- per Cum</p>
                    <p>Top</p>
                    <p>
                      Fees for installation of Lift in existing building U/s 410
                    </p>
                    <p>Permit fees for Roof Garden if sanctioned as per norm</p>
                    <p>
                      Roof Garden with restaurant or commercial use will be
                      charged for effective covered area on roof as per Table 2
                      &amp; Table 3 considering commercial rates including all
                      the charges.
                    </p>
                    <p>Fees for Revised sanction</p>
                    <p>
                      If any revised plan is submitted in modification to a
                      sanctioned building plan within its validity period then
                      the higher of the following amounts will have to be paid
                      by the applicant for revised sanction :-
                    </p>
                    <p>
                      1. The amount of sanction fees including all other charges
                      (excluding Dr. Dev. Fees) as per present submitted plan on
                      the basis of present rate in excess of the amount paid
                      during initial sanction.
                    </p>
                    <p>
                      2. 25% of the sanction fees as per present rate including
                      all other charges (excluding Dr. Dev. Fees)as would be
                      applicable from time to time.
                    </p>
                    <p>
                      In addition to the above the amount of Dr. Dev. Fees as
                      per present submitted Plan in excess of the amount paid
                      during initial sanction is to be paid. If it is found that
                      more than such payable amount is already paid during
                      initial sanction no refund will be made is refund will be
                      made.
                    </p>
                    <p>Mechanical parking Installation fees</p>
                    <p>Rs. 50,000/- Per Car Parking.</p>
                    <p>
                      The fees as stated above is for additional car parking by
                      providing Mechanical Car Parking excluding single layer
                      parking, applicable for both open and covered parking
                    </p>
                    <p>Fees for Swimming Pool</p>
                    <p>
                      1.Total fees as will be applicable for the covered area of
                      the galleries considering respective scale of fees and
                      charges has to be levied. 50% of the covered area of the
                      galleries will be taken into consideration for all
                      practical purposes.
                    </p>
                    <p>
                      2.In addition to above, 10% of the total area of the water
                      body will be taken into consideration as covered area for
                      application of fees and charges for all practical
                      purposes. Area of the bank will not be considered for any
                      fees.
                    </p>
                    <p>Top</p>
                    <p>
                      Charges for allowing temporary change of use or for
                      temporary construction allowing relaxation of existing
                      structure for construction main building (if permitted)
                    </p>
                    <p>1)</p>
                    <p>2)</p>
                    <p>3)</p>
                    <p>4)</p>
                    <p>For 2 years or part thereof</p>
                    <p>For 3 years or part thereof</p>
                    <p>For 4 years or part thereof</p>
                    <p>-</p>
                    <p>-</p>
                    <p>-</p>
                    <p>40%</p>
                    <p>50%</p>
                    <p>70%</p>
                    <p>-do-</p>
                    <p>-do-</p>
                    <p>-do-</p>
                    <p>-do-</p>
                    <p>
                      Charges for setting up of Mobile Tower or Base Tower
                      Substation [BTS] (Subject to NOC from respective
                      authority)
                    </p>
                    <p>
                      1) Sanction fees As per Fees &amp; Charges prescribed in
                      Order issued by the Department of IT &amp; E, GoWB vide
                      No. : 585-Estt / ITE-20012 / 2 / 2020, dated - 28/12/2020.
                    </p>
                    <p>
                      2) Regularization fees As per Circular issued by the
                      Department of IT &amp; E, GoWB vide No. : 1129-Estt(IT) /
                      ITE / 17011 / 2 / 2020, dated - 21/12/2022 read with
                      Circular issued by the Department of IT &amp; E, GoWB vide
                      No. : 676-Estt(IT) / ITE / 17011 / 2 / 2020, dated -
                      03/08/2022.
                    </p>
                    <p>Rate for demolition work</p>
                    <table>
                      <tr>
                        <th>Width of means of Access</th>
                        <th>Description</th>
                        <th>Rate in Rs.</th>
                        <th>Remarks</th>
                      </tr>
                      <tr>
                        <td>Upto 5.0 Mtr.</td>
                        <td>I) R.C.C. Slab/Floor (in floor area)</td>
                      </tr>
                      <tr>
                        <td>III) Beam, Column, Foundation etc.</td>
                        <td>100/- per Sqm</td>
                      </tr>
                      <tr>
                        <td>Above 5.0 to 7.0 Mtr.</td>
                        <td>I) R.C.C. Slab/Floor (in floor area)</td>
                      </tr>
                      <tr>
                        <td>III) Beam, Column, Foundation etc.</td>
                        <td>125/- per Sqm</td>
                      </tr>
                      <tr>
                        <td>Above 7.0 to 15.0 Mtr.</td>
                        <td>I) R.C.C. Slab/Floor (in floor area)</td>
                      </tr>
                      <tr>
                        <td>III) Beam, Column, Foundation etc.</td>
                        <td>150/- per Sqm</td>
                      </tr>
                      <tr>
                        <td>Above 15.0 Mtr</td>
                        <td>I) R.C.C. Slab/Floor (in floor area)</td>
                      </tr>
                      <tr>
                        <td>III) Beam, Column, Foundation etc.</td>
                        <td>200/- per Sqm</td>
                      </tr>
                      <tr>
                        <td>1.</td>
                        <td>In case of Residential Building Fees</td>
                        <td>:</td>
                        <td>
                          Rs. 5000/- per Sqm. of ground covered area of the lift
                          well including lift loby
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>In case of Office/Commercial/Factory etc.</td>
                        <td>:</td>
                        <td>
                          Rs. 12000/- per Sqm. of ground covered area of the
                          lift well including lift loby
                        </td>
                      </tr>
                      <tr>
                        <td>5)</td>
                        <td>For 1 year of part thereof</td>
                      </tr>
                      <tr>
                        <td>For 5 years or part thereof</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>-</td>
                        <td></td>
                        <td>25%</td>
                      </tr>
                      <tr>
                        <td>100%</td>
                        <td>of the basic sanction fees as per Table 2</td>
                      </tr>
                      <tr>
                        <td>
                          Note : The guidelines for sanction and regularization
                          of Mobile Tower or Base Tower Substation [BTS] and its
                          details is available in https://anumati.itewb.gov.in
                        </td>
                        <td>Rs. 12,000 per 100 sqmt.</td>
                      </tr>
                      <tr>
                        <td>Cost to be realised from person responsible</td>
                        <td>Rs. 12,000 per 100 sqmt.</td>
                      </tr>
                    </table>
                    <h2>Table 16</h2>
                    <p>
                      Fees for granting additional F.A.R - U / Rule 69A of the
                      KMC Bldg. Rules, 2009
                    </p>
                    <p>
                      Following guidelines will be followed for granting of
                      building plan with additional F.A.R for Green Buildings
                      and other categories of building as stated in Rule 69A of
                      the KMC Building Rules, 2009.
                    </p>
                    <p>
                      1) In terms of memo no. 624 / MA / O / C-4 / 3R-3 /
                      2014(Pt.) dated 09/09/2015 issued by the Joint Secretary
                      of the Govt. of West Bengal, Department of Municipal
                      Affaires, the incremental fees / charges on the additional
                      &quot;Floor Area Ratio&quot; in the following manner:
                    </p>
                    <p>
                      i) In case of &quot;Green Building&quot; the rates /
                      charges payable for availing additional &quot;Floor Area
                      Ratio&quot; as mentioned in clause (a) of sub-rule (1) of
                      rule 69A of the said rules, shall be 10% of the
                      incremental land, as per the circle rates of the Inspector
                      General (Registration) of the said land.
                    </p>
                    <p>
                      ii) In case of the other categories as mentioned in clause
                      (b) &amp; (c) of sub-rule (1) of rule 69A of the said
                      rules, the fees / charges payable for additional
                      &quot;Floor Area Ratio&quot; shall be 25% of the
                      incremental land as per &#x27;Circle rates&#x27; of the
                      Inspector General (Registration) of the said land.
                    </p>
                    <p>2) Definition of &quot;Incremental Land&quot; is :</p>
                    <p>
                      &quot;National additional land required for giving the
                      addition Floor Area Ratio&quot;
                    </p>
                    <p>
                      3) The &quot;Incremental Land&quot; may be derived as per
                      following formula :
                    </p>
                    <p>If, Area of the Land = X</p>
                    <p>Permissible FAR as per rule 69 = Y</p>
                    <p>
                      Incremental FAR as per proposal in terms of rule 69A = Z
                    </p>
                    <p>Then, Incremental Land Area = (X * Z) / Y</p>
                    <p>Example :</p>
                    <p>Let X = Land Area = say 1000 Sq.M.</p>
                    <p>Y = Permissible FAR as per 69 = say 2.00</p>
                    <p>
                      Z = Additional / Incremental FAR as per Rule 69A = say 10%
                      of Y i.e. 0.20
                    </p>
                    <p>
                      then, Incremental Land Area = (X * Z)(i.e. 10% of 1,000
                      Sq.M. = 100 Sq.M.) / Y = (1000 x 0.20) / 2.00 = 100 SqM.
                    </p>
                    <p>
                      4) Applicant has also to pay building sanction fees and
                      charges as per KMC schedule of rates including advance
                      Cess under the Building and other Constructions,
                      Workers&#x27; Welfare Cess Act, 1996 and KMDA Development
                      Charge where applicable for additional portion of
                      construction in addition to the charges levied as proposed
                      in Para 1 to 3 above.
                    </p>
                    <p>
                      5) &#x27;Circle Rates&#x27; of Inspector General
                      (Registration) of the said land should be certified by
                      Inspector General (Registration).
                    </p>
                    <p>
                      6) The applicant has to submit an undertaking that in case
                      of collection of short realization due to mistake in
                      calculation, the applicant has to pay the shortfall amount
                      if detected.
                    </p>
                    <table>
                      <tr>
                        <th>Rule</th>
                        <th>Reference</th>
                      </tr>
                      <tr>
                        <td>
                          Proposals involving rule 69A of the KMC Bldg. Rules,
                          2009
                        </td>
                        <td>
                          As per D.G. (Building) Circular 09 of 2015-16, dated
                          10/12/2015.
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BuildingDeptFees;
